import React from 'react';

import Content from '@components/Dashboard/BenefitArea/Zendrop';

const Zendrop: React.FC = () => {
  return <Content />;
};

export default Zendrop;
